module.exports = __webpack_public_path__ + "img/image_video.04f99553.png";